const GEO_LOCATION_COMPONENT_CONSTS = {
    PC: require('./view/geo_location_hybrid.html'),
    HYBRID: require('./view/geo_location_hybrid.html')
};





export {GEO_LOCATION_COMPONENT_CONSTS};
